import { createSlice } from "@reduxjs/toolkit";
import {
  createSupplierPackage,
  deleteSupplierPackage,
  fetchSupplierPackageDetails,
  fetchSupplierPackages,
  updateSupplierPackage,
} from "../actions/supplierPackageActions";

const initialState = {
  packages: {
    loading: false,
    error: null,
    data: [],
    totalCount: 0,
  },
  selectedPackage: {
    loading: false,
    error: null,
    data: null,
  },
  plantCapacityOptions: {
    loading: false,
    error: null,
    data: [],
  },
  equipmentTypes: {
    loading: false,
    error: null,
    data: [],
  },
  createUpdate: {
    loading: false,
    error: null,
    success: false,
  },
  delete: {
    loading: false,
    error: null,
    success: false,
  },
};

const supplierPackageSlice = createSlice({
  name: "supplierPackages",
  initialState,
  reducers: {
    clearSelectedPackage: (state) => {
      state.selectedPackage.data = null;
      state.selectedPackage.error = null;
    },
    clearCreateUpdateStatus: (state) => {
      state.createUpdate.loading = false;
      state.createUpdate.error = null;
      state.createUpdate.success = false;
    },
    clearDeleteStatus: (state) => {
      state.delete.loading = false;
      state.delete.error = null;
      state.delete.success = false;
    },
  },
  extraReducers: (builder) => {
    // Fetch Supplier Packages
    builder
      .addCase(fetchSupplierPackages.pending, (state) => {
        state.packages.loading = true;
        state.packages.error = null;
      })
      .addCase(fetchSupplierPackages.fulfilled, (state, action) => {
        state.packages.loading = false;
        state.packages.data = action.payload.data || [];
        state.packages.totalCount = action.payload.totalCount || 0;
      })
      .addCase(fetchSupplierPackages.rejected, (state, action) => {
        state.packages.loading = false;
        state.packages.error = action.payload;
      });

    // Fetch Package Details
    builder
      .addCase(fetchSupplierPackageDetails.pending, (state) => {
        state.selectedPackage.loading = true;
        state.selectedPackage.error = null;
      })
      .addCase(fetchSupplierPackageDetails.fulfilled, (state, action) => {
        state.selectedPackage.loading = false;
        // بک‌اند PackageModel برمی‌گرداند که شامل package است (با حروف کوچک)
        state.selectedPackage.data =
          action.payload.data?.package || action.payload.data;
      })
      .addCase(fetchSupplierPackageDetails.rejected, (state, action) => {
        state.selectedPackage.loading = false;
        state.selectedPackage.error = action.payload;
      });

    // Create Package
    builder
      .addCase(createSupplierPackage.pending, (state) => {
        state.createUpdate.loading = true;
        state.createUpdate.error = null;
        state.createUpdate.success = false;
      })
      .addCase(createSupplierPackage.fulfilled, (state) => {
        state.createUpdate.loading = false;
        state.createUpdate.success = true;
      })
      .addCase(createSupplierPackage.rejected, (state, action) => {
        state.createUpdate.loading = false;
        state.createUpdate.error = action.payload;
        state.createUpdate.success = false;
      });

    // Update Package
    builder
      .addCase(updateSupplierPackage.pending, (state) => {
        state.createUpdate.loading = true;
        state.createUpdate.error = null;
        state.createUpdate.success = false;
      })
      .addCase(updateSupplierPackage.fulfilled, (state) => {
        state.createUpdate.loading = false;
        state.createUpdate.success = true;
      })
      .addCase(updateSupplierPackage.rejected, (state, action) => {
        state.createUpdate.loading = false;
        state.createUpdate.error = action.payload;
        state.createUpdate.success = false;
      });

    // Delete Package
    builder
      .addCase(deleteSupplierPackage.pending, (state) => {
        state.delete.loading = true;
        state.delete.error = null;
        state.delete.success = false;
      })
      .addCase(deleteSupplierPackage.fulfilled, (state) => {
        state.delete.loading = false;
        state.delete.success = true;
      })
      .addCase(deleteSupplierPackage.rejected, (state, action) => {
        state.delete.loading = false;
        state.delete.error = action.payload;
        state.delete.success = false;
      });
  },
});

export const {
  clearSelectedPackage,
  clearCreateUpdateStatus,
  clearDeleteStatus,
} = supplierPackageSlice.actions;

export default supplierPackageSlice.reducer;
